import { FETCH_TEAM_SUCCEEDED } from './team.action';
import { teamInitialState } from './team.initialState';

export const teamReducer = (state = teamInitialState, action) => {
	switch (action.type) {
		case FETCH_TEAM_SUCCEEDED: {
			return action.payload;
		}

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/redux/teams/team.reducer.js